import App from './pz_masterpass/templates/pz_masterpass/';

export default App;